<template>
    <div id="plat_chat_left" class="leftContainer1">
        <div class="search_bar">
            <div style="flex:1;z-index: 999;" class="flex_center">
                <el-dropdown @command="handlecCommandChange">
                    <span class="el-dropdown-link" style="display: flex;align-items: center;">
                        <i class="iconfont icon-caidan" style="margin-right: 10px;font-weight: bold;"></i>
                    </span>
                    <template #dropdown>
                        <div class="m_color_2"
                            style="font-weight: bold; padding:5px;display: flex;justify-content: center;">
                            远程搜索
                        </div>
                        <el-dropdown-menu>
                            <el-dropdown-item :command="{ key: item.value, desc: item.desc }"
                                v-for="item in smartEnumPlugin.getEnumList('MESSAGE_FILTER_LIST')" :key="item.value">
                                <i class="iconfont" :class="item.iconClass" style="margin-right: 10px;"></i>{{ item.desc
                                }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <div style="flex:1">
                    <el-input v-model="searchKeyWords" @input="handleSearchInput" size="small" style="padding:0;"
                        placeholder="搜索">
                        <template #prefix>
                            <i class="iconfont icon-search"></i>
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="flex_center plr_10 m_desc_color"
            style=" background-color: rgba(223, 229, 244, 0.1);box-sizing: border-box;">
            <div>
                <el-tooltip effect="dark" placement="top-start">
                    <template #content>
                        <div>
                            本地过滤数据（只显示后面点亮选线的数据）,新消息会自动刷新
                        </div>
                    </template>
                    <i class="iconfont icon-a-guangqi_guolv11x"
                        :class="localFilterRef.length > 0 ? 'check_item_select' : 'check_item_init'"
                        style="cursor: pointer;" @click="handleClearLocalFilter"></i>
                </el-tooltip>
            </div>
            <div @click="handleChangeLocalFilter(item.value)" class="check_item"
                :class="[localFilterRef.includes(item.value) ? 'check_item_select' : 'check_item_init']"
                v-for="item in smartEnumPlugin.getEnumList('MESSAGE_FILTER_LIST')" :key="item.value"
                style="margin-left: 10px;">
                {{ item.desc }}
            </div>
        </div>
        <!-- 搜索好友消息 -->
        <div class="search_c" v-show="showFilterList">
            <div class="search_c__title flex_center">
                <i v-if="searchLoading" class="el-icon is-loading"><svg xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1024 1024">
                        <path fill="currentColor"
                            d="M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z">
                        </path>
                    </svg></i>
                <div class="ml_10 m_color_2">搜索结果（{{ searchFilterAccountFriendsList.length }}）</div>
                <div @click.prevent="handleCloseSearchList" class="m_color_2 mr_10"
                    style="margin-left: auto;cursor: pointer;">
                    <i class="iconfont icon-close1"></i>
                </div>
                <!-- <a @click.prevent="handleCloseSearchList" class="ml_10 m_color_e1" style="cursor: pointer;">关闭</a> -->
            </div>
            <div class="mt_2 mb_2 ml_5">
                <el-tag style="margin-right: 2px;" type="primary" v-for="item in filterRef" :key="item.key" closable
                    @close="handleRemoveFilter(item)">{{ item.desc }}</el-tag>
            </div>
            <div style="flex:1;height: 1px;position: relative;">
                <RecycleScroller ref="searchScroll" class="scroller" :items="searchFilterAccountFriendsList"
                    :item-size="67" key-field="cid" v-slot="{ item }" @scroll-end="handleSearchScrollEnd">
                    <div class="item" :class="{ on: item.cid === selectedAccountFriendId }"
                        @click="handleFriendSelect0(item)">
                        <friendItem :item="item" />
                    </div>
                </RecycleScroller>
                <div v-if="searchLoading"
                    style="display: flex;align-items: center;justify-content: center; position:absolute;bottom: 0;width:100%;height: 67px;">
                    <el-button type="danger" link :loading="searchLoading">
                        loading
                    </el-button>
                </div>
            </div>
        </div>
        <!-- END 搜索好友消息 -->


        <!-- 右键菜单 -->
        <div v-show="contextMenuVisible" :style="{ top: contextMenuTop + 'px', left: contextMenuLeft + 'px' }"
            class="context-menu">
            <div style="padding-left: 20px;padding-bottom: 5px;margin-bottom: 5px; border-bottom: 1px solid #d9d9d9;">
                操作账号：<span> {{ mentRecordItem.title || "--" }}</span>
            </div>
            <el-menu ref="menuRef" class="main-menu" @select="handleContextMenuSelect" background-color="#dbe2ef"
                active-text-color="#3f72af" text-color="#3f72af">
                <el-menu-item index="1">拉黑（不再显示该好友）</el-menu-item>
            </el-menu>
        </div>

        <div v-loading="loading" element-loading-text="Loading..."
            style="overflow-y: scroll;position: relative;flex:1;">
            <RecycleScroller ref="scroll" class="scroller" :items="showFriendList" :item-size="67" key-field="cid"
                v-slot="{ item }" @scroll-end="handleScrollEnd" @scroll-start="handleScrollStart">
                <div class="item" @click="handleFriendSelect(item)"
                    @contextmenu.prevent="handleContextMenu($event, item)"
                    :class="{ on: item.cid == selectedAccountFriendId }">
                    <friendItem :item="item" />
                </div>
            </RecycleScroller>
            <div v-if="loadingmore"
                style="display: flex;align-items: center;justify-content: center; position:absolute;bottom: 0;width:100%;height: 67px;">
                <el-button type="danger" link :loading="loadingmore">
                    loading
                </el-button>
            </div>
            <div v-if="nomoreData" style="position:absolute;bottom: 0;width:100%;">
                <el-alert type="warning" show-icon style="background-color: rgb(254,240,240,.5);">
                    <template #title>
                        <div class="flex_center">
                            没有更多数据了
                        </div>
                    </template>

                </el-alert>
            </div>
        </div>

    </div>
</template>

<script>
import { onMounted, ref, provide, inject, computed, nextTick, watch, onUnmounted } from "vue"
// import InfiniteList from 'vue3-infinite-list';
import { RecycleScroller } from 'vue-virtual-scroller'
import friendItem from "./components/friendItem.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getCtrlAccountFriendList, searchCtrlAccountFriend, blackFriend } from "@/api/chatapi";
import { SELECT_FRIEND_LIMIT } from '@/constants/common-const';
import { random } from "lodash";
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { ElMessage } from 'element-plus'
export default {
    components: { RecycleScroller, friendItem },
    setup() {
        const heightRef = ref(500)
        const smartEnumPlugin = inject("smartEnumPlugin");
        let store = useStore();
        const router = useRouter();
        const bus = inject("$eventBus");
        const wsCmd = inject("wsCmd");
        const eventbusCms = inject("eventbusCms");
        //没有更多数据
        const nomoreData = ref(false)
        //本地数据过滤()//类型：1有未读消息，2没有未读消息，3已开口，4未开口
        const localFilterRef = ref([])

        //搜索相关-------------
        const searchLoading = ref(false)
        const filterRef = ref([])
        const searchScrollEndFlag = ref(false)
        const searchScroll = ref(undefined)
        const searchKeyWords = ref('')

        //正常控制台列表相关-------------
        const scroll = ref(undefined)
        const loadingmore = ref(false)
        const scrollEndFlag = ref(false)
        const searchFilterAccountFriendsList = ref([])
        const selectAccountFriendTimmer = ref(undefined)
        const loading = computed(() => {
            return store.state.chat_store.ctrl_friend_list_loading
        })

        //--------- 搜索浮层是否显示------
        const showFilterList = computed(() => {
            return searchKeyWords.value || filterRef.value.length > 0
        })
        //-----------右键菜单---------------
        // 菜单显示状态
        const contextMenuVisible = ref(false)
        // 菜单位置
        const contextMenuTop = ref(0)
        const contextMenuLeft = ref(0)
        const menuRef = ref(null) // 菜单的 DOM 引用（关键）
        const mentRecordItem = ref({})


        //本地搜索数据
        const handleChangeLocalFilter = (type) => {
            let findIdx = localFilterRef.value.findIndex(item => item == type)
            if (findIdx >= 0) {
                localFilterRef.value.splice(findIdx, 1)
            } else {
                localFilterRef.value.push(type)
            }
        }

        const handleClearLocalFilter = async () => {
            localFilterRef.value = []
        }

        //-------------- 搜索相关方法---------------------------
        const handlecCommandChange = (cmd) => {
            if (!filterRef.value.some(item => item.key == cmd.key)) {
                filterRef.value.splice(0, filterRef.value.length, cmd)
                handleSearchFilterFriends()
            }
        }
        const handleRemoveFilter = (item) => {
            let findIdx = filterRef.value.map(item => item.key).indexOf(item.key)
            if (findIdx != -1) {
                filterRef.value.splice(findIdx, 1)
                handleSearchFilterFriends()
            }
        }
        const handleSearchInput = async () => {
            if (searchKeyWords.value.length < 1 && filterRef.value.length == 0) {
                searchFilterAccountFriendsList.value = []
                return
            }

            selectAccountFriendTimmer.value = setTimeout(() => {
                handleSearchFilterFriends()
            }, 300)
        }
        const handleCloseSearchList = async () => {
            filterRef.value = []
            searchKeyWords.value = ''
            searchFilterAccountFriendsList.value = []
        }

        //--------------右键菜单----------
        const handleContextMenu = async (e, item) => {
            e.preventDefault()
            let top = e.clientY
            // 获取视口尺寸
            const viewportHeight = window.innerHeight
            // 计算安全位置（预留 5px 边距）
            const safeMargin = 5
            //元素高度暂时设置100px
            // 获取菜单自身尺寸（需考虑边框和内边距，使用 getBoundingClientRect）
            // const menuRect = menuEl.getBoundingClientRect()
            // const menuWidth = menuRect.width
            // const menuHeight = menuRect.height
            let menuHeight = 100
            // 垂直方向调整：避免超出底部
            if (top + menuHeight > viewportHeight - safeMargin) {
                top = viewportHeight - menuHeight - safeMargin
            }

            contextMenuVisible.value = true
            contextMenuTop.value = top
            contextMenuLeft.value = e.clientX
            mentRecordItem.value = item
            // 点击其他地方隐藏菜单
            document.addEventListener('click', hideContextMenu)

        }

        // 隐藏右键菜单
        const hideContextMenu = (e) => {
            // 获取点击的目标元素
            const target = e.target

            // 判断目标是否在菜单内部（包括菜单本身及其子元素）
            const isInsideMenu = menuRef.value?.$el?.contains(target)

            // 如果点击的是菜单内部，不隐藏；否则隐藏
            if (!isInsideMenu) {
                contextMenuVisible.value = false
                document.removeEventListener('click', hideContextMenu)
            }
        }

        const handleContextMenuSelect = async (key) => {
            contextMenuVisible.value = false
            document.removeEventListener('click', hideContextMenu)
            //1 拉黑好友
            if (key == 1) {
                let fid = mentRecordItem.value.cid
                let data = { fid }
                blackFriend(data)
            }
        }
        // -------end  右键菜单



        // 防抖后的获取选项函数
        const handleSearchFilterFriends = async (loadmore) => {
            let kw = searchKeyWords.value
            if (!kw && filterRef.value.length == 0) {
                return
            }
            let searchData = {
                aid: 0,
                keyword: kw,
                action_type: filterRef.value.map(item => item.key).join(',')
            }
            searchLoading.value = true
            searchCtrlAccountFriend(searchData, loadmore)
        }

        const friendList = ref([])
        const showFriendList = computed(() => {
            //localFilterRef
            let _friendList = friendList.value
            //过滤条件
            if (localFilterRef.value.length > 0) {
                _friendList = _friendList.filter(item => {
                    if (item.cid == selectedAccountFriendId.value) {
                        return true
                    }
                    for (let v of localFilterRef.value) {
                        let res = false
                        //未读--
                        if (v == 1) {
                            res = item.new_msg_count > 0
                            if (!res) {
                                return false
                            }
                        }
                        //已开口--
                        if (v == 3) {
                            res = item.is_interact == 1 ? true : false
                            if (!res) {
                                return false
                            }
                        }

                        //线索
                        if (v == 11) {
                            res = item.save_customer_flg == 1 ? true : false
                            if (!res) {
                                return false
                            }
                        }
                        //未回
                        if (v == 5) {
                            res = item.employee_not_reply_flg == 1 ? true : false
                            if (!res) {
                                return false
                            }
                        }
                    }
                    return true
                })
            }
            return _friendList
        })


        //控制台账号好友变更
        function receiveCtrlAccountFriendList(accountFriendListResp) {
            if (accountFriendListResp && accountFriendListResp.code === 1) {
                //如果没有更多数据了给出提示
                let { data, pb } = accountFriendListResp
                let ctrl_friend_list = data?.friendlist || []
                loadingmore.value = false
                scrollEndFlag.value = false
                if (ctrl_friend_list.length == 0) {
                    store.commit('chat_store/setctrlFriendListLoading', false)
                    nomoreData.value = true
                    setTimeout(() => {
                        nomoreData.value = false
                    }, 2000);
                    // ElMessage({
                    //     message: '没有更多数据了',
                    //     type: 'warning',
                    // })
                } else {
                    store.commit('chat_store/setCtrlUserAccountFriends', accountFriendListResp)
                }
            }
        }

        //搜索账号好友列表
        function receiveCtrlSearchAccountFriendList(accountFriendListResp) {
            searchLoading.value = false
            searchScrollEndFlag.value = false

            if (accountFriendListResp && accountFriendListResp.code === 1) {
                //如果没有更多数据了给出提示
                let { data, pb, type } = accountFriendListResp
                let searchResultList = data?.friendlist || []
                if ('loadmore' == pb) {
                    let oldList = searchFilterAccountFriendsList.value || []
                    if (searchResultList.length == 0) {
                        nomoreData.value = true
                        setTimeout(() => {
                            nomoreData.value = false
                        }, 2000);
                        // ElMessage({
                        //     message: '没有更多数据了',
                        //     type: 'warning',
                        // })
                    }

                    //加载更多
                    for (let item of searchResultList) {
                        let findIdx = oldList.findIndex(_item => _item.cid == item.cid)
                        if (findIdx >= 0) {
                            let oitem = oldList[findIdx]
                            oitem = Object.assign(oitem, item)
                        } else {
                            oldList.push(item)
                        }
                    }
                    searchFilterAccountFriendsList.value = oldList || []
                } else {
                    if (type == 3) {
                        let oldList = searchFilterAccountFriendsList.value || []
                        for (let item of searchResultList) {
                            let findIdx = oldList.findIndex(_item => _item.cid == item.cid)
                            if (findIdx >= 0) {
                                let oitem = oldList[findIdx]
                                oitem = Object.assign(oitem, item)
                            } else {
                                oldList.push(item)
                            }
                        }
                        searchFilterAccountFriendsList.value = oldList || []
                    } else {
                        searchFilterAccountFriendsList.value = searchResultList || []
                    }

                }
                searchScroll.value?.updateVisibleItems(true)
            }
        }


        onMounted(() => {
            //控制台账号好友信息变更
            bus.on(`${wsCmd.cmd_34_resp}`, receiveCtrlAccountFriendList); // listen
            bus.on(`${wsCmd.cmd_35_resp}`, receiveCtrlSearchAccountFriendList); // listen

            //账号好友信息变更
            bus.on(`${wsCmd.cmd_3_resp}`, receiveCtrlSearchAccountFriendList); // listen

            const element = document.getElementById('plat_chat_left');
            const visibleHeight = element.clientHeight; // 例如：120（单位：px）
            // console.log("visibleHeight:", visibleHeight)
            heightRef.value = visibleHeight - 40
        })

        onUnmounted(() => {
            bus.off(`${wsCmd.cmd_34_resp}`,receiveCtrlAccountFriendList); // listen
            bus.off(`${wsCmd.cmd_35_resp}`,receiveCtrlSearchAccountFriendList); // listen
            bus.off(`${wsCmd.cmd_3_resp}`,receiveCtrlSearchAccountFriendList); // listen
        })
        //当前选中好友
        const selectedAccountFriendId = computed(() => {
            return store.state.chat_store.user_account_select_friend?.cid;
        });
        provide('selectedAccountFriendId', selectedAccountFriendId)
        //
        const handleFriendSelect0 = (item) => {
            let findItem = friendList.value.find(_item => _item.cid == item.cid)
            if (findItem?.cid) {
                findItem.new_msg_count = 0
            }
            handleFriendSelect(item)
        }
        const handleFriendSelect = (item) => {
            item.new_msg_count = 0
            //新缓存
            store.dispatch('chat_store/doUserAccountFriendSelect', item)
            item.new_msg_count = 0
            handleGoUrl(item)
        }
        const handleGoUrl = (item) => {
            // store.commit("wsData/SET_CHATING_FRIEND", item);
            //因为是多账号，这里需要记住哪个账号激活的是哪个好友聊天
            router.push({ name: "groupChat", query: { id: item.cid } });
            bus.emit(eventbusCms.selectFriendChange, item.cid)

        };

        const handleScrollEnd = async (e) => {
            if (scrollEndFlag.value) {
                return
            }
            scrollEndFlag.value = true
            if (!loading.value) {
                handleLoadMore()
            }
        }
        //搜索列表滚动到底部
        const handleSearchScrollEnd = async (e) => {
            if (searchScrollEndFlag.value) {
                return
            }
            searchScrollEndFlag.value = true
            if (!searchLoading.value) {
                handleSearchFilterFriendsLoadMore()
            }
        }
        // 防抖后的获取选项函数
        const handleSearchFilterFriendsLoadMore = async () => {
            let kw = searchKeyWords.value
            if (!kw && filterRef.value.length == 0) {
                return
            }
            let dataList = searchFilterAccountFriendsList.value || []
            let min_id = 0
            if (dataList.length > 0) {
                let len = dataList.length
                min_id = dataList[len - 1].cid
            }
            let searchData = {
                aid: 0,
                log_id: min_id,
                keyword: kw,
                action_type: filterRef.value.map(item => item.key).join(',')
            }
            searchLoading.value = true
            searchCtrlAccountFriend(searchData, 'loadmore')
        }



        const handleScrollStart = async () => {
            console.log('handleScrollStart==========')
        }



        const handleLoadMore = async () => {
            loadingmore.value = true
            // scroll.value.scrollToItem(50)
            let dataList = friendList.value || []
            let min_id = 0
            if (dataList.length > 0) {
                let len = dataList.length
                min_id = dataList[len - 1].cid
            }
            //获取账号好友列表
            getCtrlAccountFriendList({ aid: 0, limit: SELECT_FRIEND_LIMIT, log_id: min_id }, "loadmore")
        }

        watch(
            () => store.state.chat_store.ctrl_friend_list,
            (newValue) => {
                friendList.value = newValue
                loadingmore.value = false
                scrollEndFlag.value = false

                // scroll.value.scrollToItem(_index)
                scroll.value?.updateVisibleItems(true)
            },
            { deep: true }
        )


        return {
            scroll,
            heightRef,
            friendList,
            showFriendList,
            selectedAccountFriendId,
            searchKeyWords,
            loadingmore,
            loading,
            searchFilterAccountFriendsList,
            searchLoading,
            contextMenuVisible,
            contextMenuTop,
            contextMenuLeft,
            menuRef,
            mentRecordItem,
            filterRef,
            showFilterList,
            searchScrollEndFlag,
            searchScroll,
            nomoreData,
            smartEnumPlugin,
            localFilterRef,
            handleSearchInput,
            handleFriendSelect,
            handleFriendSelect0,
            handleLoadMore,
            handleScrollEnd,
            handleScrollStart,
            handleCloseSearchList,
            handleContextMenu,
            handleContextMenuSelect,
            handlecCommandChange,
            handleRemoveFilter,
            handleSearchScrollEnd,
            handleChangeLocalFilter,
            handleClearLocalFilter,
        }
    }
}

</script>


<style lang="scss" scoped>
.scroller {
    height: 100%;
}

.search_bar {
    height: 40px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    background-color: rgba(223, 229, 244, 0.1);
}

.leftContainer1 {
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

.item {
    font-family: 'Microsoft Yahei';
    display: flex;
    align-items: center;
    position: relative;
    height: 65px;
    overflow: hidden;
    min-width: 270px;
    overflow: hidden;
    border-radius: 5px;
    padding: 2px 5px;
    margin: 1px 5px;
    cursor: pointer;
    background-color: rgba(223, 229, 244, 0.1)
}

.item:hover {
    background-color: #e2e2e2
}

.item.on {
    /* background-color: #dedede */
    background-color: rgba(223, 229, 244, 0.9)
}

::-webkit-scrollbar {
    height: 3px;
    width: 5px;
    display: block;
}

::-webkit-scrollbar-track {
    background-color: #f3f3f3
}

::-webkit-scrollbar-track-piece {
    background: #f3f3f3
}

::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, .3);
    border-radius: 15px;
    min-height: 15px;
    width: 3px;
    transition: all .3s
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, .4)
}

::-webkit-scrollbar-thumb:active {
    background: rgba(0, 0, 0, .5)
}

// -------右键菜单--------
.context-menu {
    position: fixed;
    z-index: 9999;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    min-width: 150px;
    border: 1px solid #3f72af;
    box-sizing: border-box;
    background-color: #dbe2ef;
    padding: 10px;
    border-radius: 0 0 0 20px;
}

.main-menu {
    --el-menu-item-height: 25px;
    --el-menu-sub-item-height: calc(var(--el-menu-item-height) - 3px);
}

// ----------------- 搜索好友 ----------------
.search_c {
    position: absolute;
    top: 40px;
    z-index: 999;
    box-sizing: border-box;
    border-radius: 15px 15px 10px 10px;
    // background-color: rgba(24, 24, 24, .9);
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
}

.search_c__title {
    // background-color: rgba(24, 24, 24, 1);
    background-color: rgba(223, 229, 244, .9);
    align-items: center;
    justify-content: center;
    padding: 5px 0;
    box-shadow: 0px 10px 10px 0px rgba(255, 255, 255, 0.2);
    color: white;
    border-radius: 10px 10px 0 0;
}
</style>
